<template>
  <div class="grid grid-cols-4 m-8 w-auto md:gap-8 main-box"> 
    <div class="grid grid-cols-2 gap-2 md:gap-4 sm:w-22 box-grid ">
      <div class="box1 bg-blue-100 md:mr-12">
        <div class="icon-wrapper text-danger">
          <i class="fas fa-snowflake"></i>
        </div>
        <a href="integrate" class="text">
          <h3>Integrate</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: purple">
          <i class="fas fa-tools"></i>
        </div>
        <a href="" class="text">
          <h3>Manage</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100 md:mr-32">
        <div class="icon-wrapper" style="color: yellow">
          <i class="fas fa-chart-line"></i>
        </div>
        <a href="" id="content">
          <h3>Analyse</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: green">
          <i class="fas fa-sync-alt"></i>
        </div>
        <a href="" class="text">
          <h3>Synchronise</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: rgb(236, 105, 127)">
          <i class="fas fa-puzzle-piece"></i>
        </div>
        <a href="" class="text">
          <h3>Add-Ons</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: red">
          <i class="fas fa-cubes"></i>
        </div>
        <a href="" class="text">
          <h3>Modules</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: indigo">
          <i class="fas fa-headset"></i>
        </div>
        <a href="" class="text">
          <h3>Services</h3>
        </a>
      </div>
      <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: rgb(195, 38, 226)">
          <i class="fas fa-cogs"></i>
        </div>
        <a href="settings" class="text">
          <h3>Setting</h3>{{meta}}
        </a>
      </div>
        <div class="box1 bg-blue-100">
        <div class="icon-wrapper" style="color: rgb(195, 38, 226)">
          <i class="fas fa-cogs"></i>
        </div>
        <a href="configurations" class="text">
          <h3>Configurations</h3>{{meta}}
        </a>
      </div>
     <form method="POST" @submit.prevent="logout">
          <jet-responsive-nav-link as="button">
              Log Out
          </jet-responsive-nav-link>
      </form>
    </div>
    <!-- Right Banner -->
    <div class="col-span-3 banner w-auto">
      <div class="box bg-blue-100  banner1" >
        <h4>aruvaa</h4>
        <p>lorem12</p>
      </div>
 <div class="container card-2 pt-1 ">
        <h4>My Applications</h4>
 </div>
 <DxScrollView 
        direction="horizontal" 
        scrollByContent="true"
        scrollByThumb="true" 
        ShowScrollbar="never"
        id="scroll"  height="140px" width="100%">
   <div class="flex gap-2  ">
       <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: orangered;">
                    <i class="fas fa-spa"></i>
               </div>
        </div> 
         <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: #03b5fc;">
                  <i class="fas fa-biohazard"></i>
               </div>
        </div> 
         <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: #fc03d7;">
                   <i class="fab fa-airbnb"></i>
               </div>
        </div>  
        <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color:#fc034e;">
                   <i class="fab fa-atlassian"></i>
               </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: peru;">
                  <i class="fas fa-th"></i>
               </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: rgb(49, 255, 66);">
                  <i class="fas fa-globe"></i> 
               </div>
        </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: hotpink">
                <i class="fas fa-sun"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(238, 225, 41)">
                <i class="fas fa-asterisk"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(63, 196, 205)">
                <i class="fas fa-fan"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(9, 109, 39)">
                <i class="fas fa-feather-alt"></i>
              </div>
            </div>
   </div>
 </DxScrollView>
    <div class="container card-2">
        <h4 class="pt-2  ">Recommendation</h4> 
    </div>
      <!-- right 2 card -->
     <DxScrollView 
        direction="horizontal" 
        scrollByContent="true"
        scrollByThumb="true" 
        ShowScrollbar="never"
        id="scroll"  height="140px" width="100%">
   <div class="flex gap-2 ">
<!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: bg-green-300;">
         <i class="fab fa-battle-net"></i>
               </div>
        </div>
        <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: #98fc03;">
        <i class="fas fa-bezier-curve"></i>
               </div>
        </div>
        <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: #03fcb1;">
          <i class="fas fa-cannabis"></i>
               </div>
        </div>
            <!-- card one -->
             <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: rgb(255, 251, 0);">
          <i class="fas fa-star"></i>
               </div>
        </div> 
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: rgb(255, 170, 85);">
          <i class="fas fa-scroll"></i>
               </div>
        </div>
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: rgb(61, 124, 67);">
          <i class="fas fa-map"></i> 
               </div>
        </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(255, 5, 130)">
                <i class="fas fa-laptop"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(4, 46, 122)">
                <i class="fas fa-anchor"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(63, 205, 117)">
                <i class="fas fa-dice-d20"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(129, 63, 205)">
                <i class="fas fa-shield-alt"></i>
              </div>
            </div>
      </div>
 </DxScrollView>
    </div>
 </div>
  <!-- </div> -->
</template>
<script>
import DxScrollView from 'devextreme-vue/scroll-view';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
export default {
  components: {
      DxScrollView ,
      JetResponsiveNavLink
  },
    methods: {
            logout() {
                this.$inertia.post(route('logout'));
            },
        }
}
</script>
<style scoped>
/* Red border */
hr.new1 {
  border-top: 1px solid grey;
}
@media  (max-width: 992px){
  .box-grid{
    display: none;
  } 
}
@media  (max-width: 992px){
 .box-grid{
   display: none;
 } 

}
@media only screen and (min-width: 992px){
  .box5-grid{
   display: none;
 }
}
/* Large devices (tab, 952px and up) */

@media only screen and (min-width: 992px){
  .box5-grid{
   display: none;
 }

}
/* Large devices (tab, 952px and up) */

@media  (max-width: 992px){
 .box-grid{
   display: none;
 }  
}
@media only screen and (min-width: 992px){
  .box5-grid{
   display: none;
 }
}
@media (min-width: 768px) {
  .box1 {
    height: 90px;
    width: 90px;
  }
  .cad {
    /* padding: 38px 10px; */
    justify-content: space-between;
    margin-right: 1px;
    /* margin-left: 10px; */
  }
}
.icon-wrappe{
    text-align: left;
    margin: 17px 10px;
    font-size: x-large;
  }

.icon-wrappe{
    text-align: left;
    margin: 17px 10px;
    font-size: x-large;
  }

/* For desktop view */
.box {
  padding: 40px;
  /* margin-left: 13px; */
  height: auto;
  width: 94%;
  border: 2px solid rgb(121, 226, 226);
}
.box1 {
  height: 112px;
  width: 110px;
  border: 2px solid rgb(121, 226, 226);
}

.icon-wrapper {
  /* text-decoration: none; */
  text-align: left;
  margin: 20px 12px;
  font-size: xx-large;
}
.banner1{
  width: 100%;
}
.banner{
 margin-right: 50px; 
}
.text h3 {
  font-size: 17px;
  text-decoration: none;
  margin-left: 10px;
  text-align: left;
  color: #191c23;
  margin-bottom: 8px;
}

a .text h3 {
  text-decoration: none;
}
#content {
  overflow: hidden;
  width: 100px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
#content h3 {
  color: #191c23;
  font-size: 17px;
  margin-left: 10px;
}
.box3 {
  height: 133px;
  width: 113px;
  border: 2px solid rgb(121, 226, 226);
}
.icon-wrapper-1 {
  margin: auto;
  text-align: center;
  font-size: 30px;
  margin-top: 30px;
}
/* right banner */
.cad {
  /* padding: 38px 10px; */
  border-radius: 10px;
  color: #2567b3;
  justify-content: space-between;
  margin-right: 110px;
  /* margin-left: 10px; */
}
.card-2 h4{
text-align: start;
}
/* right scrooll  card */
</style>
